<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-text-field
          v-model="search"
          label="Search..."
          dense
          outlined
          hide-details
          class="shrink mx-4"
          title="Search By Title, Product Code, Idea"
        ></v-text-field>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn class="mx-4" @click="convertDataJSON">Export To Excel</v-btn>
      </v-row>
    </v-col>

    <v-simple-table fixed-header style="text-align: left">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Image</th>
            <th class="text-left" @click="sortData('product_code')">Title
              <v-icon x-small v-if="sortBy == 'product_code' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'product_code' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left">Idea</th>
            <th class="text-left" @click="sortData('utm_term')">UTM Term
              <v-icon x-small v-if="sortBy == 'utm_term' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'utm_term' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('utm_campaign')">UTM Campaign Name
              <v-icon x-small v-if="sortBy == 'utm_campaign' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'utm_campaign' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('utm_medium')">UTM Medium
              <v-icon x-small v-if="sortBy == 'utm_medium' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'utm_medium' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('total_orders')">Total Orders
              <v-icon x-small v-if="sortBy == 'total_orders' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'total_orders' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('total_sales')">Total Sales
              <v-icon x-small v-if="sortBy == 'total_sales' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'total_sales' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('revenue')">Revenue
              <v-icon x-small v-if="sortBy == 'revenue' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'revenue' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('ad_spent')">
              FB Ad Spent
              <v-icon x-small v-if="sortBy == 'ad_spent' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'ad_spent' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
            <th class="text-left" @click="sortData('temp_net_profit')">
              Temp Net Profit
              <v-icon x-small v-if="sortBy == 'temp_net_profit' && !sortType"
                >mdi-arrow-up</v-icon
              >
              <v-icon
                x-small
                v-else-if="sortBy == 'temp_net_profit' && sortType"
                >mdi-arrow-down</v-icon
              >
              <v-icon x-small v-else>mdi-arrow-up-down</v-icon>
            </th>
          </tr>
          <tr style="border-bottom:1px solid #d3d3d3;">
            <td colspan="6" style="text-align: right;"><b>Total</b></td>
            <td><b>{{totalData.total_total_orders.toFixed(2)}}</b></td>
            <td><b>{{totalData.total_total_sales.toFixed(2)}}</b></td>
            <td><b>{{totalData.total_revenue.toFixed(2)}}</b></td>
            <td><b>{{totalData.total_ad_spent.toFixed(2)}}</b></td>
            <td><b>{{totalData.total_temp_profit.toFixed(2)}}</b></td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, indexitem) in filterItems">
            <tr :key="indexitem">
              <td>
                <a target="_blank" :href="item.product_thumbnail"><img :src="item.product_thumbnail" width="80px" /></a>
              </td>
              <td>
                <div>{{ item.product_code }}</div>
                <a
                  @click="showNameItem(item)"
                  v-if="item.showName == false"
                  style="text-align: justify"
                  >{{ item.short_title }}</a
                >
                <a
                  @click="showNameItem(item)"
                  v-else
                  style="text-align: justify"
                  >{{ item.product_title }}</a
                >
              </td>
              <td>
                {{ item.idea }}
              </td>
              <td>{{ item.utm_term }}</td>
              <td>{{ item.utm_campaign }}</td>
              <td>{{ item.utm_medium }}</td>
              <td>{{ item.total_orders }}</td>
              <td>{{ item.total_sales }}</td>
              <td>{{ item.revenue.toFixed(2) }}</td>
              <td>
                {{ item.ad_spent.toFixed(2) }}
              </td>
              <td>
                {{ item.temp_net_profit.toFixed(2) }}
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>


<script>
import axios from "axios";
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";
import XLSX from "xlsx";
import moment from "moment";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "ProfitProductFBSum",
  props: {
    report_type: String,
    report_month: Array,
    store_codes: Array,
    listIdeaSelected: Array,
  },
  data: () => ({
    search: "",
    loading: false,
    productProfitData: [],
    showBtn: null,
    informText: "",
    convertData: {
      ProductProfit: [],
    },
    filterItems: [],
    sortBy: "",
    sortType: null,
    totalData:{},
  }),

  watch: {
    search() {
      this.filterData(this.search);
    },
  },

  methods: {
    /*
    sumField(key) {
      // sum data in give key (property)
      return this.filterItems.reduce((a, b) => a + (b[key] || 0), 0);
    },
    */

    async loadData() {
      this.loading = true;

      var queryParams = {
        report_type: this.report_type,
        store_codes: this.store_codes.join(","),
      };

      if (this.listIdeaSelected.length >= 0) {
        queryParams["ideas"] = this.listIdeaSelected.join(",");
      }

      if (this.report_month.length > 0) {
        if (this.report_month[0] > this.report_month[1]) {
          queryParams["report_from"] = this.report_month[1];
          queryParams["report_to"] = this.report_month[0];
        } else {
          queryParams["report_from"] = this.report_month[0];
          queryParams["report_to"] = this.report_month[1];
        }
      }

      console.log(queryParams);

      var currentSession = await this.$root.$refs.App.currentSession(
        "product-profit-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "reports/profit", {
            headers: { Authorization: currentSession.accessToken },
            params: queryParams,
          })
          .then((response) => {
            console.log("response: ", response);
            this.convertToArray(response.data.data);
            /*
            this.filterItems = JSON.parse(
              JSON.stringify(this.productProfitData)
            );
            */

            //console.log("this.productProfitData: ", this.productProfitData);
            this.filterItems = JSON.parse(
              JSON.stringify(this.productProfitData)
            );
            this.loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession product-profit-loadData-undefined: ",
          currentSession
        );
      }
    },

    convertToArray(data) {
      // for (var id in data) {
      //   this.productProfitData.push(data[id]);
      // }

      this.productProfitData = JSON.parse(JSON.stringify(data));

      this.totalData = {
        total_total_orders:0,
        total_total_sales:0,
        total_revenue: 0,
        total_ad_spent:0,
        total_temp_profit:0,
      }

      for (const y of this.productProfitData) {
        if (y.product_title) {
          y["short_title"] = y.product_title.substring(0, 35).concat("...");
          y["showName"] = false;
        }

        this.totalData.total_ad_spent += y.ad_spent
        this.totalData.total_total_orders += y.total_orders
        this.totalData.total_revenue += y.revenue
        this.totalData.total_total_sales += y.total_sales
        this.totalData.total_temp_profit += y.temp_net_profit
      }
    },

    filterData(input) {
      //console.log("input: ", input);
      if (input != "") {
        this.filterItems = [];

        this.filterItems = this.productProfitData.filter(
          (t) =>
            t.product_title.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            t.product_code.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            t.idea.toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            t.utm_term.toString().toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            t.utm_campaign.toString().toLowerCase().indexOf(input.toLowerCase()) > -1 ||
            t.utm_medium.toString().toLowerCase().indexOf(input.toLowerCase()) > -1
        );

        this.totalData = {
          total_total_orders:0,
          total_total_sales:0,
          total_revenue: 0,
          total_ad_spent:0,
          total_temp_profit:0,
        }
        
        for (const y of this.filterItems) {
          this.totalData.total_ad_spent += y.ad_spent
          this.totalData.total_total_orders += y.total_orders
          this.totalData.total_revenue += y.revenue
          this.totalData.total_total_sales += y.total_sales
          this.totalData.total_temp_profit += y.temp_net_profit
        }
      } else {
        this.filterItems = JSON.parse(JSON.stringify(this.productProfitData));

        this.totalData = {
          total_total_orders:0,
          total_total_sales:0,
          total_revenue: 0,
          total_ad_spent:0,
          total_temp_profit:0,
        }
        
        for (const y of this.filterItems) {
          this.totalData.total_ad_spent += y.ad_spent
          this.totalData.total_total_orders += y.total_orders
          this.totalData.total_revenue += y.revenue
          this.totalData.total_total_sales += y.total_sales
          this.totalData.total_temp_profit += y.temp_net_profit
        }
      }
    },

    showNameItem(item) {
      var data = this.filterItems.filter(
        (t) => t.product_code == item.product_code
      );
      if (data[0].showName == false) {
        data[0].showName = true;
      } else {
        data[0].showName = false;
      }

      this.$forceUpdate();
    },

    convertDataJSON() {
      //console.log(this.productProfitData)
      for (const i of this.productProfitData) {
        //console.log("i: ", i);
          var temp = {
            Image: i.product_thumbnail,
            "Product Code": i.product_code,
            Title: i.product_title,
            Idea: i.idea,
            "UTM Term": i.utm_term,
            "UTM Campaign Name": i.utm_campaign,
            "UTM Medium": i.utm_medium,
            "Total Order": i.total_orders,
            "Total Sales": i.total_sales,
            Revenue: parseFloat(i.revenue).toFixed(2),
            "FB Ad Spent": parseFloat(i.ad_spent).toFixed(2),
            "Temp Net Profit": parseFloat(i.temp_net_profit).toFixed(2),
          }
          this.convertData.ProductProfit.push(temp);
        
      }

      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      for (const a in this.convertData) {
        var b = XLSX.utils.json_to_sheet(this.convertData[a]);
        XLSX.utils.book_append_sheet(wb, b, a);
      }

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      //XLSX.utils.book_append_sheet(wb, animalWS, 'animals') // sheetAName is name of Worksheet
      //XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')
      var current = moment().format("YYYY-MM-DD-h-mm-ss");
      // export Excel file
      XLSX.writeFile(wb, "product_fb_summary_profit_" + current + ".xlsx"); // name of the file is 'book.xlsx'
    },

    check() {
      console.log(this.editedItem);
    },

    sortData(col) {
      this.sortBy = col;
      if (this.sortType == null) {
        this.sortType = false;
      } else {
        this.sortType = !this.sortType;
      }

      if (this.sortType == false)
        this.filterItems.sort((a, b) => (a[col] > b[col] ? 1 : -1));
      else this.filterItems.sort((a, b) => (a[col] < b[col] ? 1 : -1));
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    console.log("report_type: ", this.report_type);
    console.log("report_month: ", this.report_month);
    console.log("store_codes: ", this.store_codes);
    console.log("listIdea: ", this.listIdeaSelected);
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.v-data-table /deep/ .sticky-header {
  position: sticky;
  top: 0;
}

.v-data-table /deep/ .v-data-table__wrapper {
  overflow: unset;
}
</style>